// Mangoes
export const GET_MANGOES_LOADING = "GET_MANGOES_LOADING";
export const GET_MANGOES_SUCCESS = "GET_MANGOES_SUCCESS";
export const GET_MANGOES_ERROR = "GET_MANGOES_ERROR";

// Fruits 
export const GET_FRESH_FRUITS_LOADING = "GET_FRESH_FRUITS_LOADING";
export const GET_FRESH_FRUITS_SUCCESS = "GET_FRESH_FRUITS_SUCCESS";
export const GET_FRESH_FRUITS_ERROR = "GET_FRESH_FRUITS_ERROR";

export const GET_EXOTIC_FRUITS_LOADING = "GET_EXOTIC_FRUITS_LOADING";
export const GET_EXOTIC_FRUITS_SUCCESS = "GET_EXOTIC_FRUITS_SUCCESS";
export const GET_EXOTIC_FRUITS_ERROR = "GET_EXOTIC_FRUITS_ERROR";

export const GET_COMBOS_FRUITS_LOADING = "GET_COMBOS_FRUITS_LOADING";
export const GET_COMBOS_FRUITS_SUCCESS = "GET_COMBOS_FRUITS_SUCCESS";
export const GET_COMBOS_FRUITS_ERROR = "GET_C0MBOS_FRUITS_ERROR";



// Vegetables 
export const GET_DAILY_VAGETABLES_LOADING = "GET_DAILY_VAGETABLES_LOADING";
export const GET_DAILY_VAGETABLES_SUCCESS = "GET_DAILY_VAGETABLES_SUCCESS";
export const GET_DAILY_VAGETABLES_ERROR = "GET_DAILY_VAGETABLES_ERROR";

export const GET_EXOTIC_VAGETABLES_LOADING = "GET_EXOTIC_VAGETABLES_LOADING";
export const GET_EXOTIC_VAGETABLES_SUCCESS = "GET_EXOTIC_VAGETABLES_SUCCESS";
export const GET_EXOTIC_VAGETABLES_ERROR = "GET_EXOTIC_VAGETABLES_ERROR";

export const GET_CUTS_PEELED_LOADING = "GET_CUTS_PEELED_LOADING";
export const GET_CUTS_PEELED_SUCCESS = "GET_CUTS_PEELED_SUCCESS";
export const GET_CUTS_PEELED_ERROR = "GET_CUTS_PEELED_ERROR";

export const GET_COMBOS_VAGETABLES_LOADING = "GET_COMBOS_VAGETABLES_LOADING";
export const GET_COMBOS_VAGETABLES_SUCCESS = "GET_COMBOS_VAGETABLES_SUCCESS";
export const GET_COMBOS_VAGETABLES_ERROR = "GET_C0MBOS_VAGETABLES_ERROR";

export const GET_HERBS_LEAFS_LOADING = "GET_HERBS_LEAFS_LOADING";
export const GET_HERBS_LEAFS_SUCCESS = "GET_HERBS_LEAFS_SUCCESS";
export const GET_HERBS_LEAFS_ERROR = "GET_HERBS_LEAFS_ERROR";

// Dry Fruits
export const GET_DRY_FRUITS_LOADING = "GET_DRY_FRUITS_LOADING";
export const GET_DRY_FRUITS_SUCCESS = "GET_DRY_FRUITS_SUCCESS";
export const GET_DRY_FRUITS_ERROR = "GET_DRY_FRUITS_ERROR";

// Best deals
export const GET_BEST_DEALS_LOADING = "GET_BEST_DEALS_LOADING";
export const GET_BEST_DEALS_SUCCESS = "GET_BEST_DEALS_SUCCESS";
export const GET_BEST_DEALS_ERROR = "GET_BEST_DEALS_ERROR";

export const GET_SINGLE_PRODUCT_LOADING = "GET_SINGLE_PRODUCT_LOADING";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_ERROR = "GET_SINGLE_PRODUCT_ERROR  ";
